import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateDE'
})
export class DEDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe = new DatePipe('de-DE')) {

  }

  transform(value: any, _format?: string, _timezone?: string): any {
    return this.datePipe.transform(value, 'medium','CET');
  }

  transformIso(value: any, _format?: string, _timezone?: string): any {
    return this.datePipe.transform(value, 'short', 'UTC');
  }

  transformToIso(value: any, _format?: string, _timezone?: string): any {
    return this.datePipe.transform(value, 'YYYY-MM-DDTHH:mm', 'UTC');
  }
}
